import { lazy, Suspense } from 'react';
import { Link, Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop.jsx';
import { Toaster } from '@/components/ui/sonner';

const HomePage = lazy(() => import('./pages/HomePage.jsx'));
const AboutPage = lazy(() => import('./pages/AboutPage.jsx'));
const PrintingPage = lazy(() => import('./pages/PrintingPage.jsx'));
const SendMoneyPage = lazy(() => import('./pages/SendMoneyPage.jsx'));
const ShippingPage = lazy(() => import('./pages/ShippingPage.jsx'));
const ContactPage = lazy(() => import('./pages/ContactPage.jsx'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage.jsx'));
const TermsPage = lazy(() => import('./pages/TermsPage.jsx'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={
        <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">
          Loading...
        </div>
      }>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/printing" element={<PrintingPage />} />
          <Route path="/send-money" element={<SendMoneyPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={
            <div className="flex min-h-screen items-center justify-center bg-background">
              <div className="px-4 text-center">
                <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
                <p className="mb-8 text-xl text-muted-foreground">Page not found</p>
                <Link to="/" className="text-primary hover:underline">Back to home</Link>
              </div>
            </div>
          } />
        </Routes>
      </Suspense>
      <Toaster />
    </Router>
  );
}

export default App;
